import React from 'react';
import PropTypes from 'prop-types';
import MyCardItem from './MyAppCardItem';
import getContent from '../lib/dictionaryFetcher';
import { Link } from '@paypalcorp/pp-react';

const SearchResult = props => {
  const {
    toggleFavorite,
    result,
    search,
    clearSearch,
    setApp,
    setTool,
    user
  } = props;

  const renderResult = () => {
    if (!result) return null;

    const toolBtnTextActive = getContent(
        'merchanthub',
        `tools.button.active`,
        ''
      ),
      toolBtnTextInactive = getContent(
        'merchanthub',
        `tools.button.inactive`,
        ''
      );

    return result.map((tool, index) => {
      if (!tool) return null;
      let isTool = tool.type === 'tool',
        toolBtnText = tool.active ? toolBtnTextActive : toolBtnTextInactive,
        btnText = isTool
          ? toolBtnText
          : getContent('merchanthub', `apps.${tool.key}.button`, ''),
        callback = isTool ? setTool : setApp;

      return (
        <MyCardItem
          key={index}
          item={tool}
          toggleFavorite={toggleFavorite}
          btnText={btnText}
          callback={callback}
          app={tool.key}
          user={user}
        />
      );
    });
  };

  const RenderResultText = () =>
    getContent(
      'merchanthub',
      `search.${result.length > 1 ? 'results' : 'result'}`,
      undefined,
      {
        useHTML: true,
        params: {
          size: result.length,
          search
        }
      }
    );

  return (
    <div id="tools-search-result">
      <p>
        <span>
          <RenderResultText />
        </span>
        <Link as="button" id="clear-search-link" onClick={clearSearch}>
          {getContent('merchanthub', 'search.clear')}
        </Link>
      </p>
      {renderResult()}
    </div>
  );
};

SearchResult.propTypes = {
  result: PropTypes.array,
  user: PropTypes.object,
  search: PropTypes.string,
  clearSearch: PropTypes.func,
  toggleFavorite: PropTypes.func,
  setTool: PropTypes.func,
  setApp: PropTypes.func
};

export default SearchResult;
